import { Box, Modal, Typography } from "@mui/material";
import React from "react";
import cssClasses from "./AllotmentDetails.module.css";
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";
import Button from "../../Subcomponents/Button";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import ReactTimeAgo from "react-time-ago";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en.json";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator,
} from "@mui/lab";
import DoneIcon from "@mui/icons-material/Done";
import CircleIcon from "@mui/icons-material/Circle";
import * as _ from "lodash";
import Dot from "../../Components/Icons/Dot";
import Close from "../../Components/Icons/Close";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

const useStyles = makeStyles((theme) => ({
  tokenName: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "2rem",
    lineHeight: "3rem",
    color: "#000000",
  },
  wrapperIcons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-around",
    marginBottom: "2rem",
    position: "relative",
  },
  closeIcon: {
    cursor: "pointer",
    position: "absolute",
    right: "1.7rem",
    top: "1.7rem",
  },
  title: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.8rem",
    lineHeight: "2.8rem",
    color: "#101828",
    marginBottom: "0.8rem",
  },
  subTitle: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  labelCard: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  labelValue: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  wrapperButtons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    columnGap: "1.2rem",
  },
  backArrow: {
    verticalAlign: "middle",
  },
}));
const AllotmentDetails = ({ open, handleClose, returnRes, data }) => {
  console.log(data);
  const classes = useStyles();
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  TimeAgo.setDefaultLocale(en.locale);
  TimeAgo.addLocale(en);
  function closeModal() {
    handleClose();
  }
  function numberWithCommas(x) {
    return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
  }
  const allotmentTransactions = _.orderBy(
    data.AllotmentTransactions,
    "created_at",
    "desc"
  );
  console.log("allotmentTransactions: ", allotmentTransactions);
  const timeLine = allotmentTransactions.map((timelineItem, timelineIndex) => {
    // timelineIndex === 1 &&
    //   timelineItem?.status === "Claimed" &&
    //   data.AllotmentTransactions[data.AllotmentTransactions.length - 1]?.status === "Unclaimed" ? (
    //   <></>
    // ) :
    return (
      <Timeline
        position="right"
        sx={[
          {
            padding: "0rem !important",
            [`& .MuiTimeline-root `]: {
              padding: "0rem !important",
            },

            "& . MuiTypography-root": {
              padding: "19px 16px !important",
            },
            [`& .MuiTimelineItem-root:before`]: {
              flex: "0rem !important",
              padding: "0rem !important",
              "-webkitFlex": "none !important",
              //  content:'none '
            },
          },
        ]}
      >
        <TimelineItem
          key={`TimelineItem_${timelineIndex}`}
          color={timelineIndex === 0 ? `primary` : "grey"}
        >
          <TimelineSeparator>
            <TimelineDot sx={{ backgroundColor: "rgba(11, 165, 236, 0.3)" }}>
              {timelineItem.isCompleted ? (
                <DoneIcon />
              ) : (
                <DoneIcon
                  className={
                    timelineIndex === 0 ? cssClasses.active : cssClasses.all
                  }
                />
              )}
            </TimelineDot>
            {timelineIndex !== data.AllotmentTransactions.length - 1 && (
              <TimelineConnector
                sx={{ backgroundColor: "rgba(11, 165, 236, 0.3)" }}
              />
            )}
          </TimelineSeparator>
          <TimelineContent>
            <Typography
              // fontFamily={"Roboto-Regular"}
              //  color={timelineIndex===0 ? `primary` : "#667085"}
              fontSize={"1.4rem"}
              style={{
                paddingTop: "1rem",
                textDecoration: timelineItem.isCompleted
                  ? "line-through"
                  : "none",
              }}
            >
              <div
                style={{
                  fontSize: "1.6rem",
                  fontFamily: "Inter-Medium",
                  color: "#000000",
                  lineHeight: "2rem",
                  verticalAlign: "middle",
                  marginRight: "0.5rem",
                }}
              >
                Transaction {timelineItem.status}
                {/* {timelineItem.status} */}
              </div>
              <div
                style={{
                  fontSize: "1.4rem",
                  fontFamily: "Inter-Medium",
                  color: "#475467",
                  lineHeight: "1.8rem",
                  verticalAlign: "middle",
                  // marginRight: "0.5rem",
                  marginTop: "0.5rem",
                }}
              >
                {timelineItem.modeOfPayment},{" "}
                {numberWithCommas(timelineItem.amount)}
              </div>
              <div
                style={{
                  fontSize: "1.4rem",
                  fontFamily: "Inter-Medium",
                  color: "#475467",
                  lineHeight: "1.8rem",
                  verticalAlign: "middle",
                  // marginRight: "0.5rem",
                  marginTop: "0.5rem",
                }}
              >
                {new Date(timelineItem.created_at).toDateString()},{" "}
                {new Date(timelineItem.created_at).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </div>
              <div
                style={{
                  fontSize: "1.4rem",
                  fontFamily: "Inter-Medium",
                  color: "#475467",
                  lineHeight: "1.8rem",
                  verticalAlign: "middle",
                  // marginRight: "0.5rem",
                  marginTop: "0.5rem",
                }}
              >
                Pay Id: {timelineItem.payId ? timelineItem.payId : "-"}
              </div>
              {timelineItem.modeOfPayment === "Virtual acc" && (
                <div
                  style={{
                    fontSize: "1.4rem",
                    fontFamily: "Inter-Medium",
                    color: "#475467",
                    lineHeight: "1.8rem",
                    verticalAlign: "middle",
                    // marginRight: "0.5rem",
                    marginTop: "0.5rem",
                  }}
                >
                  {data.leadId.virtualAccId}
                </div>
              )}
              {timelineItem.paymentLinkId &&
                timelineItem.paymentLinkId !== "script" && (
                  <div
                    style={{
                      fontSize: "1.4rem",
                      fontFamily: "Inter-Medium",
                      color: "#475467",
                      lineHeight: "1.8rem",
                      verticalAlign: "middle",
                      // marginRight: "0.5rem",
                      marginTop: "0.5rem",
                    }}

                    // onClick={() => {
                    //     window.open('https://razorpay.com/payment-link/' + timelineItem.paymentLinkId, 'blank')
                    // }}
                  >
                    {timelineItem.paymentLinkId}
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        window.open(
                          process.env.REACT_APP_RAZORPAY_PAYMENT_LINK_URL +
                            timelineItem.paymentLinkId,
                          "_blank"
                        );
                      }}
                    >
                      <OpenInNewIcon
                        sx={{
                          fontSize: "1.6rem",
                          verticalAlign: "middle",
                          color: "#344054",
                          cursor: "pointer",
                          marginLeft: "0.5rem",
                        }}
                      />
                    </span>
                  </div>
                )}
              {/* <InfoOutlinedIcon
                    style={{
                      fontSize: "2rem",
                      verticalAlign: "middle",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      if (
                        timelineItem?.Reason === "" ||
                        timelineItem?.Reason === null
                      ) {
                        errorTost("No Information available");
                      } else {
                        setConfirmationAlertModal(true);
                        setReasonMessage(timelineItem?.Reason);
                      }
                    }}
                  ></InfoOutlinedIcon> */}
                        </Typography>
                    </TimelineContent>
                </TimelineItem>
            </Timeline>
        );
    });
    return (
        <Modal
            open={open}
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    closeModal();
                }
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={[
                {
                    ".MuiBackdrop-root": {
                        background: "rgba(52, 64, 84, 0.7)",
                    },
                },
            ]}
            disableAutoFocus={true}
        >
            <Box className={cssClasses.modalWrapper}>
                <div className={cssClasses.wrapperHeader}>
                    <span className={classes.closeIcon} onClick={closeModal} tabIndex={0}>
                        <Close width={"1.2rem"} height={"1.2rem"} />
                    </span>
                    <div>Allotment Details</div>
                </div>
                <div className={cssClasses.wrapperContent}>
                    <div className={cssClasses.cardHeader}>
                        <div className={cssClasses.tokenNumWrap}>
                            {data.unitId &&
                                <>
                                    {/* <span>{data.unitId.wingId.wingName} - {data.unitId.unitNo}{" "}</span> */}
                                    <span>{data.unitId.wingId.displayName ? data.unitId.wingId.displayName : data.unitId.wingId.wingName} - {data.unitId.unitNo}{" "}</span>
                                    <span>|</span>
                                    <span>{data.unitId.projectId.projectName}</span>
                                </>
                            }
                            {data.inventoryMergedId &&
                                <>
                                    {data.inventoryMergedId.unit1Id.wingId.wingId === data.inventoryMergedId.unit2Id.wingId.wingId &&
                                        <span>{data.inventoryMergedId.unit1Id.wingId.displayName ? data.inventoryMergedId.unit1Id.wingId.displayName : data.inventoryMergedId.unit1Id.wingId.wingName} - {data.inventoryMergedId.unit1No} && {data.inventoryMergedId.unit2No}</span>
                                    }
                                    {data.inventoryMergedId.unit1Id.wingId.wingId !== data.inventoryMergedId.unit2Id.wingId.wingId &&
                                        <span>{data.inventoryMergedId.unit1Id.wingId.displayName ? data.inventoryMergedId.unit1Id.wingId.displayName : data.inventoryMergedId.unit1Id.wingId.wingName} - {data.unitId.unitNo}{" "}</span>
                                    }
                                    <span>|</span>
                                    <span>{data.inventoryMergedId.projectId.projectName}</span>
                                </>
                            }
                        </div>
                        <div className={cssClasses.tokenStatus}>
                            {
                                data.status === 'partial' &&
                                <LeadStatusChip
                                    label={'Partial'}
                                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                    style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
                                ></LeadStatusChip>
                            }
                            {data.status === 'complete' && (data.paidAmount >= (data?.unitId?.projectId?.bookingAmt + data.SDR)) &&
                                <LeadStatusChip
                                    label={'Complete'}
                                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                    style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                                ></LeadStatusChip>
                            }
                            {data.status === 'pending' &&
                                <LeadStatusChip
                                    label={'Pending'}
                                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                    style={{ color: "#B42318", backgroundColor: "#FEF3F2" }}
                                ></LeadStatusChip>
                            }
                            {/* ? if 5,00,000 amount is paid; check for SDR amount */}
                            {data.status === 'complete' && (data.paidAmount >= data?.unitId?.projectId?.bookingAmt && (data.paidAmount - data?.unitId?.projectId?.bookingAmt < data.SDR)) &&
                                <LeadStatusChip
                                    label={'SDR Payment Pending'}
                                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                    style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
                                ></LeadStatusChip>
                            }
                            {data.status === 'expired' &&
                                <LeadStatusChip
                                    label={'Expired'}
                                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                    style={{ color: "#0E7090", backgroundColor: "#ECFDFF" }}
                                ></LeadStatusChip>}
                        </div>
                        <div className={cssClasses.tokenLastUpdate}>
                            <ReactTimeAgo
                                style={{ fontSize: "1.2rem" }}
                                date={data?.last_updated_at ?? data?.created_at}
                                locale="en-US"
                            />
                        </div>
                    </div>
                    <div className={cssClasses.cardDetails}>
                        <div className={cssClasses.allotmentDetails}>
                            <div className={cssClasses.tokenDetails}>
                                {data.paymentId && (
                                    <div className={cssClasses.tokenData}>
                                        <span>{data.paymentId?.eventTokenId?.eventId?.title}</span>
                                    </div>
                                )}
                                <div className={cssClasses.tokenData}>
                                    {data.unitId &&
                                        <>
                                            {/* <span>{data.unitId.inventoryTypeId.type}</span> */}
                                            {data?.unitId?.projectId?.displayInventoryType?.includes(
                                                "Inventory Type"
                                            ) ? (
                                                <span>{data.unitId.inventoryTypeId.type}</span>
                                            ) : (
                                                ""
                                            )}
                                            {data?.unitId?.projectId?.displayInventoryType?.includes(
                                                "Display Unit Type"
                                            ) ? (
                                                <span>{"(" + data.unitId.displayUnitType + ")"}</span>
                                            ) : (
                                                ""
                                            )}
                                            <span>|</span>
                                            <span>{data.unitId.floorNo}</span>
                                        </>
                                    }
                                    {data.inventoryMergedId &&
                                        <>
                                            {data.inventoryMergedId.unit1Id.inventoryTypeId.type === data.inventoryMergedId.unit2Id.inventoryTypeId.type &&
                                                <span>{data.inventoryMergedId.unit1Id.inventoryTypeId.type}</span>
                                            }
                                            {data.inventoryMergedId.unit1Id.inventoryTypeId.type !== data.inventoryMergedId.unit2Id.inventoryTypeId.type &&
                                                <span>{data.inventoryMergedId.unit1Id.inventoryTypeId.type} - {data.inventoryMergedId.unit2Id.inventoryTypeId.type}</span>
                                            }
                                            <span>|</span>
                                            {data.inventoryMergedId.unit1Id.floorNo === data.inventoryMergedId.unit2Id.floorNo &&
                                                <span>{data.inventoryMergedId.unit1Id.floorNo}</span>
                                            }
                                            {data.inventoryMergedId.unit1Id.floorNo !== data.inventoryMergedId.unit2Id.floorNo &&
                                                <span>{data.inventoryMergedId.unit1Id.floorNo} - {data.inventoryMergedId.unit2Id.floorNo}</span>
                                            }
                                        </>
                                    }
                                </div>
                                <div className={cssClasses.tokenData}>
                                    <span>Alloted on : </span>
                                    <span>{new Date(data.created_at).toDateString()}, {new Date(data.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>
                                </div>
                            </div>
                            <div className={cssClasses.cardFooter}>
                                <div className={cssClasses.totalAmt}>
                                    <span>Total Amount : </span>
                                    {/* {data.pricingType === 'preselect' ?
                                        <span>₹{' '}{numberWithCommas(data.paymentId.amount)}</span> :
                                        <span>₹{' '}{numberWithCommas(data.bookingAmt.total)}</span>
                                    } */}
                                    {
                                        <span>₹{' '}{numberWithCommas(data.bookingAmt.total)}</span>
                                    }
                                    {/* <span>₹ 5,00,000</span> */}
                                </div>
                                <div className={cssClasses.paidAmt}>
                                    <span>Paid Amount : </span>
                                    <span>₹{' '}{numberWithCommas(data.paidAmount)}</span>
                                </div>
                                {/* <div className={cssClasses.paidAmt}>
                                <span>Paid On : </span>
                                <span></span>
                            </div> */}
              </div>
            </div>

            <div className={cssClasses.transactionDetails}>{timeLine}</div>
          </div>
        </div>
        <div className={cssClasses.wrapperFooter}>
          <Button
            style={{
              color: "#ffffff",
              backgroundColor: "#155EEF",
              fontSize: "1.6rem",
              lineHeight: "2.4rem",
              width: "auto",
            }}
            btnName={"OK"}
            clicked={() => {
              closeModal();
            }}
            //   disable={disabeNext}
          />
        </div>
      </Box>
    </Modal>
  );
};

export default AllotmentDetails;
